import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CoachingStaffTable from "./CoachingStaffTable";
import WBCCollapse from "../elements/WBCCollapse";
import Tooltip from "../elements/Tooltip";
import * as _ from "lodash";
import CoachingStaffConstants from "../../constants/CoachingStaffConstants";

const CoachingStaffSectionSubtitle = styled.p`
  font-family: Helvetica;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  margin-left: 0.5rem;
  color: ${props => props.theme["dark-grey"]};
  &.min-not-met {
    color: ${props => props.theme["mlb-red"]};
  }
`;

const InfoIcon = styled.i`
  margin-left: 0.5rem;
  color: ${props => props.theme["wbcBlue"]};
  cursor: pointer;
  font-size: 14px;
`;

const CoachingStaffSection = ({ staff, isWBCI, personnel, setUniformUpdates }) => {
  const infoIconRef = useRef(null);

  const title = (
    <div className="d-flex flex-row">
      {staff?.type?.length > 0 ? _.startCase(staff?.type?.toLowerCase()) : "null"}
      {staff?.min && (
        <>
          <CoachingStaffSectionSubtitle className={personnel?.length < staff?.min ? "min-not-met" : ""}>
            minimum - {staff?.min}
          </CoachingStaffSectionSubtitle>
          <CoachingStaffSectionSubtitle className={personnel?.length > staff?.max ? "max-not-met" : ""}>
            maximum - {staff?.max}
          </CoachingStaffSectionSubtitle>
          {personnel?.length > staff?.max && (
            <CoachingStaffSectionSubtitle
              style={{ color: "red" }}
              className={personnel?.length > staff?.max ? "max-not-met" : ""}
            >
              Maximum number of {staff?.max} {staff?.type?.toLowerCase()} exceeded. Please remove{" "}
              {personnel?.length - staff?.max} staff.
            </CoachingStaffSectionSubtitle>
          )}
        </>
      )}
      {staff.type === CoachingStaffConstants.PERSONNEL_TYPE.TEAM_STAFF && (
        <div>
          <>
            <InfoIcon ref={infoIconRef} className="fas fa-info-circle" />
            <Tooltip targetRef={infoIconRef} placement="right">
              Staff that fall under this section will appear in a banner at the top of the Final Roster Export
            </Tooltip>
          </>
        </div>
      )}
    </div>
  );

  return (
    <WBCCollapse title={title} startsOpen={true} className="py-1">
      <CoachingStaffTable
        isWBCI={isWBCI}
        data={personnel}
        maxRows={staff?.max || personnel?.length}
        staffType={staff?.type}
        setUniformUpdates={setUniformUpdates}
      />
    </WBCCollapse>
  );
};

CoachingStaffSection.propTypes = {
  staff: PropTypes.object.isRequired,
  isWBCI: PropTypes.bool.isRequired,
  personnel: PropTypes.array.isRequired,
  setUniformUpdates: PropTypes.func.isRequired
};

export default CoachingStaffSection;
